/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Show_Error_Details_ButtonInputs */

const en_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show details`)
};

const id_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilkan detail`)
};

const ms_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunjukkan butiran`)
};

const ca_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veure detalls`)
};

const cs_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit podrobnosti`)
};

const da_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis detaljer`)
};

const de_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details anzeigen`)
};

const et_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuva üksikasjad`)
};

const es_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver información`)
};

const fr_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les détails`)
};

const hr_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokažite informacije`)
};

const it_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra dettagli`)
};

const lv_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rādīt detalizētu informāciju`)
};

const lt_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rodyti išsamią informaciją`)
};

const hu_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Részletek megjelenítése`)
};

const nl_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details weergeven`)
};

const nb_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis detaljer`)
};

const pl_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż szczegóły`)
};

const pt_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar detalhes`)
};

const ro_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afișează detaliile`)
};

const sk_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobraziť podrobnosti`)
};

const sl_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prikaži podrobnosti`)
};

const fi_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä tiedot`)
};

const sv_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa information`)
};

const vi_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiển thị thông tin`)
};

const tr_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayrıntıları görüntüle`)
};

const el_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εμφάνιση λεπτομερειών`)
};

const bg_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показване на подробностите`)
};

const ru_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать детали`)
};

const sr_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прикажи детаље`)
};

const uk_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показати деталі`)
};

const ka_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დეტალების ჩვენება`)
};

const hi_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिटेल्स दिखाएं`)
};

const th_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แสดงรายละเอียด`)
};

const ko_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세부 정보 표시`)
};

const zh_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示详情`)
};

const zh_tw_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顯示詳細資料`)
};

const ja_show_error_details_button = /** @type {(inputs: Show_Error_Details_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細を表示`)
};

/**
* | output |
* | --- |
* | "Show details" |
*
* @param {Show_Error_Details_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const show_error_details_button = /** @type {((inputs?: Show_Error_Details_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Show_Error_Details_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_show_error_details_button(inputs)
	if (locale === "ms") return ms_show_error_details_button(inputs)
	if (locale === "ca") return ca_show_error_details_button(inputs)
	if (locale === "cs") return cs_show_error_details_button(inputs)
	if (locale === "da") return da_show_error_details_button(inputs)
	if (locale === "de") return de_show_error_details_button(inputs)
	if (locale === "et") return et_show_error_details_button(inputs)
	if (locale === "es") return es_show_error_details_button(inputs)
	if (locale === "fr") return fr_show_error_details_button(inputs)
	if (locale === "hr") return hr_show_error_details_button(inputs)
	if (locale === "it") return it_show_error_details_button(inputs)
	if (locale === "lv") return lv_show_error_details_button(inputs)
	if (locale === "lt") return lt_show_error_details_button(inputs)
	if (locale === "hu") return hu_show_error_details_button(inputs)
	if (locale === "nl") return nl_show_error_details_button(inputs)
	if (locale === "nb") return nb_show_error_details_button(inputs)
	if (locale === "pl") return pl_show_error_details_button(inputs)
	if (locale === "pt") return pt_show_error_details_button(inputs)
	if (locale === "ro") return ro_show_error_details_button(inputs)
	if (locale === "sk") return sk_show_error_details_button(inputs)
	if (locale === "sl") return sl_show_error_details_button(inputs)
	if (locale === "fi") return fi_show_error_details_button(inputs)
	if (locale === "sv") return sv_show_error_details_button(inputs)
	if (locale === "vi") return vi_show_error_details_button(inputs)
	if (locale === "tr") return tr_show_error_details_button(inputs)
	if (locale === "el") return el_show_error_details_button(inputs)
	if (locale === "bg") return bg_show_error_details_button(inputs)
	if (locale === "ru") return ru_show_error_details_button(inputs)
	if (locale === "sr") return sr_show_error_details_button(inputs)
	if (locale === "uk") return uk_show_error_details_button(inputs)
	if (locale === "ka") return ka_show_error_details_button(inputs)
	if (locale === "hi") return hi_show_error_details_button(inputs)
	if (locale === "th") return th_show_error_details_button(inputs)
	if (locale === "ko") return ko_show_error_details_button(inputs)
	if (locale === "zh") return zh_show_error_details_button(inputs)
	if (locale === "zh-tw") return zh_tw_show_error_details_button(inputs)
	if (locale === "ja") return ja_show_error_details_button(inputs)
	return en_show_error_details_button(inputs)
});